// organization flags
export const SHOULD_ALLOW_MULTIPLE_ADMINS = 'trello-power-up-all-admin-feature';
export const SHOULD_ALLOW_ANYONE_TO_CLEAR_DATA = 'trello-power-up-allow-anyone-to-clear-data';
export const CAN_EXPOSE_BOARD_SYNC_FROM_MIRROR = 'trello-powerup-expose-board-sync-from-mirror';
export const SHOULD_FETCH_CACHED_CONTAINERS = 'trello-power-up-fetch-cached-containers';
